import { useEffect, useState } from 'react';

// helpers
import {
  fetchCrossSellData,
  crossSellRequestDefaults,
} from '@zola-helpers/client/dist/es/crossSell';

// types
import {
  CrossSellResponse,
  CrossSellRequestConfig,
} from '@zola-helpers/client/dist/es/crossSell/types';

const useGetCrossSellData = (
  requestObj: CrossSellRequestConfig = crossSellRequestDefaults
): { crossSellData: CrossSellResponse | null; isBusy: boolean } => {
  const [isBusy, setIsBusy] = useState(true);
  const [crossSellData, setCrossSellData] = useState<CrossSellResponse | null>(null);

  useEffect(() => {
    if (isBusy) {
      fetchCrossSellData(requestObj)
        .then((res) => {
          if (res) {
            setCrossSellData(res);
            setIsBusy(false);
          }
        })
        .catch(() => {
          setCrossSellData(null);
          setIsBusy(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { crossSellData, isBusy };
};

export default useGetCrossSellData;
